import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from 'react-router-dom';
import _ from 'lodash';

import './FilterButtons.scss';
import { RootState } from '../../../configs/store';
import Icon from '../../Icon/Icon';

function Filterbuttons() {
  const { t } = useTranslation(['common']);
  const history = useHistory();
  const location = useLocation();

  const { optionsType } = useSelector((state: RootState) => state.filters);
  const dispatch = useDispatch();

  useEffect(() => {
    async function getOptionsSelected() {
      const query = new URLSearchParams(location.search);
      const types = query.get('type') && query.get('type').split(',');

      if (types) {
        const urlTypes = _.reduce(optionsType, (acc, value, key) => {
          return { ...acc, [key]: types.indexOf(key) !== -1 };
        }, {});

        if (!_.isEqual(urlTypes, optionsType)) {
          await dispatch.filters.setAllOptionsTypes(urlTypes);
        }
      }
    }

    getOptionsSelected();
  }, []);

  const filterEvents = (type) => async (e) => {
    e.preventDefault();

    optionsType[type] = !optionsType[type];

    const urlTypes = _.reduce(optionsType, (acc, value, key) => {
      if (value === true) {
        return [ ...acc, key ];
      } else {
        return acc;
      }
    }, []);

    const query = new URLSearchParams(location.search);
    if (query.get('type') !== urlTypes.toString()) {
      history.replace({
        pathname: location.pathname,
        search: `?calendar=${ query.get('calendar') || '' }&type=${ urlTypes }`
      });
    }
  };

  const renderButton = (type) => {
    const stateValue = optionsType[type];

    return (
      <div className="racing-filters__container">
        <button
          className={
            classNames({
              'racing-filters__btn': true,
              [`racing-filters__btn--${ type }`]: true,
              'racing-filters__btn--disable': !stateValue
            })
          }
          onClick={ filterEvents(type) }
        >
          <Icon icon={ type } />
        </button>
        <span
          className={
            classNames({
              'racing-filters__placeholder': true,
              [`racing-filters__placeholder--${ type }`]: true,
              'racing-filters__placeholder--disable': !stateValue
            })
          }
        >
          { t(`sideBar.${ type }`) }
        </span>
      </div>
    );
  };

  return (
    <div className="racing-filters">
      { renderButton('horses') }
      { renderButton('carriages') }
      { renderButton('dogs') }
    </div>
  );
}

export default Filterbuttons;
